(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('saasScanStatusWidget', ["path", "$q", "secAppsStatusDao", function (path, $q, secAppsStatusDao) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('summary-report/saas-scan-status').template('saas-scan-status'),
            scope: {
                saas: '=?',
                securityApps: '=?'
            },
            link: function ($scope, element, attrs) {
                $scope.saas = $scope.saas || {};
                $scope.loading = true;
                $scope.securityApps = $scope.securityApps || [];
                var timeoutDeferred = $q.defer();
                $scope.scanStatusConf = {
                    periods: [
                        {
                            hours: 0,
                            label: 'Total',
                            highlight: true
                        },
                        {
                            hours: 7 * 24,
                            label: 'Week'
                        },
                        {
                            hours: 7 * 30,
                            label: 'Month'
                        }
                    ]
                };
                $scope.load = function () {
                    var results = [];
                    var queries = [];
                    timeoutDeferred.resolve();
                    timeoutDeferred = $q.defer();
                    _($scope.securityApps).each(function (app) {
                        var row = {
                            app: app,
                            data: []
                        };
                        results.push(row);
                        _($scope.scanStatusConf.periods).each(function (period) {
                            var result = { loading: true };
                            row.data.push(result);
                            queries.push(secAppsStatusDao.counts(app.name, 'success_unmatch', period.hours, $scope.saas.name).timeout(timeoutDeferred.promise).then(function (res) {
                                result.loading = false;
                                result.value = res.data || 0;
                            }));
                        });
                    });
                    return $q.all(queries).then(function () {
                        $scope.scanStatusRows = _(results).filter(function (row, idx) {
                            return _(row.data).find(function (data) {
                                return data.value;
                            });
                        });
                        $scope.loading = false;
                    });
                };
                if (!_($scope.saas).isEmpty()) {
                    $scope.load();
                }
                $scope.$on('$locationChangeStart', function (event, next) {
                    timeoutDeferred.resolve();
                });
            }
        };
    }]);
}());